import { getItem } from '@/lib/utils'
import ajax from '@/lib/axios'
import { EDU_ANNER, RATE_LIST, FAQ_CATEGORY_LIST, CATEGORY_LIST, PROMOTION_LIST, PROMO_BANNER } from '@/lib/constant'
import { IBlogOpts } from './interface/post'
import ajaxBot from './bot-axios'

export const fetchAllBlog = async (
  page = 1,
  per_page = 10,
  sticky = false,
  fields = 'id,content,_links,_embedded,title,slug,date,excerpt',
) => {
  const categoryIds = CATEGORY_LIST.map((item) => item.id)
  const params: IBlogOpts = {
    page: page,
    per_page: per_page,
    hide_empty: true,
    _embed: true,
    categories: categoryIds.toString(),
    _fields: fields,
    key: `fetchAllBlog_${page}_${per_page}_${sticky}`,
  }
  if (sticky) {
    params.sticky = sticky
  }
  return ajax.get(`/posts`, { params })
}

export const fetchPintarBlog = async (page = 1, per_page = 10, fields = 'id,title,slug,date') => {
  const params: IBlogOpts = {
    page: page,
    per_page: per_page,
    hide_empty: true,
    _embed: true,
    _fields: fields,
    key: `fetchPintarBlog_${page}_${per_page}`,
  }
  return ajax.get(`/posts`, { params })
}

export const fetchBlogBySlug = (slug: any) => {
  const params = {
    slug,
    _embed: true,
    hide_empty: true,
    ignore_sticky: true,
    key: `fetchBlogBySlug_${slug}`,
  }
  return ajax.get(`/posts`, { params })
}

export const searchBlogByWords = async (search: string | string[]) => {
  const categoryIds = CATEGORY_LIST.map((item) => item.id)
  const params = {
    search: search,
    _embed: true,
    _fields: 'id,content,_links,_embedded,title,slug,date',
    categories: `${categoryIds}`,
    key: `searchBlogByWords_${search}`,
  }
  return ajax.get(`/posts`, { params })
}

export const fetchBlogById = (id: string) => {
  const params = {
    _embed: true,
    hide_empty: true,
    key: `fetchBlogById_${id}`,
  }
  return ajax.get(`/posts/${id}`, { params })
}

export const fetchCategoryById = (id, page, per_page) => {
  const params = {
    categories: id,
    page,
    per_page,
    _embed: true,
    _fields: 'id,content,_links,_embedded,title,slug,date,excerpt',
    key: `fetchCategoryById_${page}_${per_page}_${id}`,
  }
  return ajax.get(`/posts`, { params })
}

export const fetchTagById = (id, page, per_page, fields = 'id,content,_links,_embedded,title,slug,date,excerpt') => {
  const params = {
    tags: id,
    page,
    per_page,
    _embed: true,
    _fields: fields,
    key: `fetchTagById_${page}_${per_page}_${id}`,
  }
  return ajax.get(`/posts`, { params })
}

export const fetchTagBySlug = (slug: string) => {
  const params = {
    slug,
    _fields: 'id,name,slug',
    hide_empty: true,
    ignore_sticky: true,
    key: `fetchTagBySlug_${slug}`,
  }
  return ajax.get(`/tags`, { params })
}

export const fetchAllTags = (page = 1, per_page = 10) => {
  const params = {
    _fields: 'id,name,slug',
    page,
    per_page,
    key: `fetchAllTags_${page}_${per_page}`,
  }
  return ajax.get(`/tags`, { params })
}

export const fetchTagsByGroup = (page = 1, per_page = 10, groups = []) => {
  const params = {
    _fields: 'id,name,slug,groups',
    page,
    per_page,
    key: `fetchTagsByGroup_${page}_${per_page}`,
  }
  return ajax.get(`/tag-groups`, { params }).then((res: any) => {
    const tags = res.filter((item) => groups.includes(item.groups[0]))
    return {
      data: tags ? tags.slice((page - 1) * per_page, page * per_page) : [],
      total: tags ? tags.length : 0,
    }
  })
}

export const fetchCategoryBySlug = (slug: string) => {
  const params = {
    slug,
    _fields: 'id,name,slug',
    _embed: true,
    ignore_sticky: true,
    key: `fetchCategoryBySlug_${slug}`,
  }
  return ajax.get(`/categories`, { params })
}

/** -- education page ----- banner */
export const fetchEduBannerPage = () => {
  const cache_data = getItem('_kp_eduBanner')
  if (cache_data) {
    Promise.resolve().then(() => {
      return cache_data
    })
  }
  const params = {
    key: `fetchEduBannerPage`,
  }
  return ajax.get(`/pages/${EDU_ANNER}`, { params })
}
/** -- FAQ page ----- RateList */
export const fetchRateListPage = () => {
  const params = {
    key: `fetchRateListPage`,
  }
  return ajax.get(`/pages/${RATE_LIST}`, { params })
}
/** -- FAQ page ----- CategoryList */
export const fetchCategoryListPage = () => {
  const params = {
    key: `fetchCategoryListPage`,
  }
  return ajax.get(`/pages/${FAQ_CATEGORY_LIST}`, { params })
}
/** -- Home page ----- PromotionList */
export const fetchPromotionListPage = () => {
  const params = {
    key: `fetchPromotionListPage`,
  }
  return ajax.get(`/pages/${PROMOTION_LIST}`, { params })
}

/** -- Home page ----- PromotionBanner */
export const fetchPromoBannerPage = () => {
  const params = {
    key: `fetchPromoBannerPage`,
  }
  return ajax.get(`/pages/${PROMO_BANNER}`, { params })
}

export const fetchAllByNext = (page, per_page) => {
  return ajax.get(`${process.env.NEXT_PUBLIC_HOST_URL}/api/fetch-all-blog?page=${page}&per_page=${per_page}&_embed`)
}

export const submitByProduct = (form: any) => {
  return ajax.post(`${process.env.NEXT_PUBLIC_HOST_URL}/api/kp-websites`, {
    title: 'kp-wb',
    data: form,
  })
}

export const fetchEconsentTokenValidation = (token: string) => {
  return ajaxBot.post<any>(`/contact-consent/token-valid`, { token })
}

export const fetchEconsentPhoneValidation = (token: string, phone: string) => {
  return ajaxBot.post<any>(`/contact-consent/confirmation`, { token, last4DigitPhoneNumber: phone })
}

export const fetchEconsentLzdTokenValidation = (token: string) => {
  return ajaxBot.post<any>(`/lzd/contact-consent/token-valid`, { token })
}

export const fetchEconsentLzdPhoneValidation = (token: string, phone: string) => {
  return ajaxBot.post<any>(`/lzd/contact-consent/confirmation`, { token, last4DigitPhoneNumber: phone })
}
